import { AppsOrder } from "@zapier/bff";
import { RouterOutputs, trpc } from "../trpc";
import { keepPreviousData } from "@tanstack/react-query";

export type PrivateApp = RouterOutputs["app"]["privateApps"]["results"][number];

interface Input {
  limit?: number;
  offset?: number;
  ordering?: AppsOrder;
  search?: string;
  selectedApis?: string[];
}

interface Options {
  enabled?: boolean;
}

export function useQueryPrivateApps(
  { limit = 25, offset = 0, search, selectedApis, ordering }: Input,
  { enabled }: Options = {},
) {
  const { data, isFetching, isLoading } = trpc.app.privateApps.useQuery(
    {
      limit,
      offset,
      ordering,
      search,
      selectedApis,
    },
    {
      enabled,
      placeholderData: keepPreviousData,
      staleTime: Infinity, // Apps don't change often, only refetch on user action
      trpc: {
        context: {
          // Skip batching to avoid bundling this critical procedure with slower requests
          skipBatching: true,
        },
      },
    },
  );

  return {
    totalCount: data?.count || 0,
    apps: (data?.results || []) as any[],
    isLoading,
    isFetching,
  };
}
